<script setup>
import { watchEffect } from 'vue';

import { Amplify } from 'aws-amplify';
import { events } from 'aws-amplify/data';
import { useBreakStore } from '@/stores/break';
import { logDebug } from '@/utils/logger';

const appInstance = import.meta.env.VITE_APP_ENV;
const ampUrl = import.meta.env.VITE_APP_AMP_URL;
const ampKey = import.meta.env.VITE_APP_AMP_KEY;
const catchErrorPrefix = import.meta.env.VITE_APP_CATCH_ERROR_PREFIX;

const storeBreak = useBreakStore();

// console.log(`Project mode: ${appMode}`);
// console.log(`Project instance: ${appInstance}`);

const props = defineProps({
  interactiveBreakUuid: {
    type: String,
    required: true,
  },
});

Amplify.configure({
  API: {
    Events: {
      endpoint: ampUrl,
      region: 'us-east-1',
      defaultAuthMode: 'apiKey',
      apiKey: ampKey,
    },
  },
});

const qrIdent = storeBreak.qrIdent;
const channelName = `/transactions/${qrIdent}`;

events.connect(channelName).then((channel) => {
  channel.subscribe({
    next: (receivedData) => {
      storeBreak.hasProductBeenPurchased = true;

      logDebug(`received data: ${receivedData}`);
    },
    error: (errorResponse) => {
      fetch(
        `${catchErrorPrefix}${appInstance}/appSyncError?ib_uuid=${props.interactiveBreakUuid}&error=${errorResponse}`,
      );
    },
  });

  fetch(
    `${catchErrorPrefix}${appInstance}/appSyncError?ib_uuid=${props.interactiveBreakUuid}&channel_name=${channelName}`,
  );

  logDebug(`subscribed to ${channelName}`);
});

// // BarcodeQr watchers

watchEffect(() => {
  if (storeBreak.hasProductBeenPurchased) {
    setTimeout(() => {
      logDebug(`stopping transaction animation`);

      storeBreak.hasProductBeenPurchased = false;
    }, 3000);
  }
});
</script>

<template>
  <div v-if="storeBreak.hasProductBeenPurchased" class="transaction">
    <div class="transaction__container">
      <div class="transaction__info">
        <span class="transaction__info-text"
          >Thank you for your purchase! Your program will resume shortly.</span
        >
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use './transactionbarcodeqr.scss';
</style>
